export default {
  data() {
    return {
      windowWidth: null,
      iframeHeight: null,
      ready: false,
      generatingPdf: false,
      generatedPdfUrl: "",
      generatedPdfFilename: "",
    };
  },

  mounted() {
    document.getElementsByTagName("html")[0].classList.add("overflow-x-hidden", "no-touch");
    document.body.classList.add("public", "overflow-x-hidden", "no-touch");
    this.ready = true;
  },

  created() {
    window.addEventListener("resize", this.resizeIframe);

    window.addEventListener("message", (event) => {
      if (event.data && event.data.frame_height) {
        if (this.windowWidth !== window.outerWidth) {
          this.iframeHeight = Number(event.data.frame_height) + 40;
          this.resizeIframe();
          this.windowWidth = window.outerWidth;
        }
      }
    });
  },

  destroyed() {
    window.removeEventListener("resize", this.resizeIframe);
  },

  methods: {
    openPdf() {
      if (this.generatingPdf) {
        return;
      }

      this.generatingPdf = true;
      this.generatedPdfFilename = `${this.invoice.is_quote ? "Quote" : "Invoice"} ${
        this.invoice.invoice_number
      }.pdf`;

      // Detect if is iOS Chrome or iOS Firefox
      if (navigator.userAgent.match("CriOS") || navigator.userAgent.match("FxiOS")) {
        this.$http
          .get(`/invoices/${this.invoice.uuid}/pdf-by-uuid?online=true`)
          .then((response) => {
            this.generatePdfOnline(response);
          });
      } else {
        this.$http
          .get(`/invoices/${this.invoice.uuid}/pdf-by-uuid`, { responseType: "arraybuffer" })
          .then((response) => {
            this.generatePdfBlob(response);
          });
      }
    },

    generatePdfOnline(response) {
      this.generatedPdfUrl = response.body;

      window.location = this.generatedPdfUrl;

      this.generatingPdf = false;
    },

    generatePdfBlob(response) {
      // const blob = new Blob([response.data], { type: 'application/pdf' });
      const blob = new Blob([response.data], { type: "text/html; charset=UTF-8" }); // Need this to trigger download on iOS Safari
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = this.generatedPdfFilename;
      link.click();

      this.generatingPdf = false;
    },

    resizeIframe() {
      if (this.windowWidth === window.outerWidth) {
        return;
      }

      const container = document.querySelector(".public-invoice .invoice-container");
      const iframe = document.querySelector(".public-invoice iframe");

      if (container === null || iframe === null) {
        return;
      }

      const ratio = (container.clientWidth - 20) / 1180;

      iframe.style.transform = `scale(${ratio})`;
      iframe.height = this.iframeHeight;
      container.style.height = `${iframe.height * ratio + 48}px`;
    },
  },
};
